export default "__VITE_ASSET__DA6kA7L$__"